// Org-chart label guardrail for the F11 multiempresa model.
//
// After F11 a department's "primary" company is RECONSTRUCTED on the API side
// (`deptMemberships[0]?.company ?? null`), so `department.company` is legitimately
// nullable. Every UI site that shows a company name must go through this helper so
// a missing primary degrades to a visible fallback instead of crashing with
// `reading 'name' of null`, and is never dropped silently (ISO traceability).

export function companyName(company: { name: string } | null | undefined): string {
  return company?.name ?? 'Sin empresa';
}
